import { IUserMissionAim, IUserSupporter } from 'src/@types/apiResponse';
import { IChatbot, IMissionDetail, IMissionHistory, IMissionHistoryDetail } from 'src/models';
import { IUpdateSupporterData } from 'src/screens';
import { IUpdateAimData } from 'src/screens/calendar/quit-smoking-aim/components/EditQuitSmokingAim';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/** 챗봇 초기 호출 */
export const initChat = async () => {
  try {
    const url = `/chatbot/init`;

    const response = await instance.get<TApiResponseData<IChatbot[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 사용자 메시지 전달 */
export const progressChatbot = async (userInput: string[], isMission?: string) => {
  try {
    const url = `/chatbot/chat`;
    const payload = {
      user_input: userInput,
      is_mission: isMission,
    };

    const response = await instance.post<TApiResponseData<IChatbot[]>>(url, payload);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 미션 진행도 조회 */
export const getMissionHistory = async () => {
  try {
    const url = `/mission/progress`;

    const response = await instance.get<TApiResponseData<IMissionHistory[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 미션 진행도 상세 조회 */
export const getMissionHistoryDetail = async (targetWeek: string) => {
  try {
    const url = `/mission/progress/detail?week=${targetWeek}`;

    const response = await instance.get<TApiResponseData<IMissionHistoryDetail>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 미션 상세 조회 */
export const getMissionDetail = async (targetWeek: string, order: string) => {
  try {
    const url = `/mission/progress/history/detail?week=${targetWeek}&order=${order}`;

    const response = await instance.get<TApiResponseData<IMissionDetail[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 금연 실패 확률 조회 */
export const getPredict = async () => {
  try {
    const url = `/chatbot/predict`;

    const response = await instance.get<TApiResponseData<any>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 금연 목표 조회 */
export const getUserAim = async () => {
  try {
    const url = `/userMissionData/aim`;

    const response = await instance.get<TApiResponseData<IUserMissionAim>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 금연 목표 수정 */
export const updateUserAim = async (aimData: IUpdateAimData) => {
  try {
    const url = `/userMissionData/update/aim`;

    const response = await instance.put<TApiResponseData<IUserMissionAim>>(url, aimData);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 사회적 지지자 조회 */
export const getUserSupporter = async () => {
  try {
    const url = `/userMissionData/supporter`;

    const response = await instance.get<TApiResponseData<IUserSupporter>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 사회적 지지자 설정 */
export const setUserSupporter = async (supporter: IUpdateSupporterData) => {
  try {
    const url = `/userMissionData/supporter`;

    const response = await instance.post<TApiResponseData<IUserSupporter>>(url, supporter);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 사회적 지지자 수정 */
export const updateUserSupporter = async (
  supporter: IUpdateSupporterData,
  userMissionDataSid: number,
) => {
  try {
    const url = `/userMissionData/supporter/${userMissionDataSid}`;

    const response = await instance.put<TApiResponseData<IUserSupporter>>(url, supporter);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
